/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Date: 2019-01-15 19:30:58
 */

/**
 * Created by WJX on 2017/11/22.
 */
import DefaultPage from '@/components/DefaultPage.vue'; // TODO: vux
// import { InlineLoading } from 'vux';

import InlineLoading from 'vux/src/components/inline-loading';
export var loadMore = {
  data: function data() {
    return {
      showDefaultPage: false //显示缺省页面

    };
  },
  methods: {
    /*
     * cb 回调
     *
     * */
    preLoad: function preLoad(cb) {
      var h = document.documentElement.scrollHeight,
          t = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop,
          wh = document.documentElement.clientHeight; // console.log(t / (h - wh))

      if (t / (h - wh) > 0.6) {
        if (cb) {
          cb();
        }
      }
    }
  },
  computed: {},
  components: {
    DefaultPage: DefaultPage,
    InlineLoading: InlineLoading
  },
  created: function created() {}
};